import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Anchor, AnchorLink, Button} from 'kpc';

var _$tmp0 = {
    'href': 'section_one',
    'title': 'section1'
};
var _$tmp1 = {
    'href': 'section_two',
    'title': 'section2'
};
var _$tmp2 = {
    'href': 'section_three',
    'title': 'section3'
};
var _$tmp3 = {
    'id': 'section_one'
};
var _$tmp4 = {
    'id': 'section_two'
};
var _$tmp5 = {
    'id': 'section_three'
};
var _$tmp6 = {
    'id': 'scroll-container2'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Anchor, {
            'vertical': false,
            'container': '#scroll-container2',
            'ev-click': this.handleAnchorClick,
            'ev-change': this.handleAnchorChange,
            'children': [
                _$cc(AnchorLink, _$tmp0),
                _$cc(AnchorLink, _$tmp1),
                _$cc(AnchorLink, _$tmp2)
            ],
            'ev-$model:value': function($v) {
                $this.set('activeAnchor', $v);
            },
            'value': $this.get('activeAnchor')
        }),
        _$ce(2, 'div', [
            _$ce(2, 'div', (
                _$ce(2, 'h2', 'Section1', 16 /* HasTextChildren */)
            ), 2 /* HasVNodeChildren */, 'section section1', _$tmp3),
            _$ce(2, 'div', (
                _$ce(2, 'h2', 'Section2', 16 /* HasTextChildren */)
            ), 2 /* HasVNodeChildren */, 'section section2', _$tmp4),
            _$ce(2, 'div', (
                _$ce(2, 'h2', 'Section3', 16 /* HasTextChildren */)
            ), 2 /* HasVNodeChildren */, 'section section3', _$tmp5)
        ], 4 /* HasNonKeyedChildren */, 'scroll-container2', _$tmp6),
        (this.get('logs').length) ?
            _$ce(2, 'div', this.get('logs').map((log, index) => _$ce(2, 'div', log, 0 /* UnknownChildren */, null, null, index)), 0 /* UnknownChildren */, 'logs-container') :
            undefined
    ], 0 /* UnknownChildren */, 'anchor-demo');
};